"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/* eslint-disable no-underscore-dangle */
var _attendeeId = Symbol('attendeeId');

var _capabilities = Symbol('capabilities');

var _dataDevice = Symbol('dataDevice');

var _dialPlan = Symbol('dialPlan');

var _displayName = Symbol('displayName');

var _domain = Symbol('domain');

var _email = Symbol('email');

var _firstName = Symbol('firstName');

var _gravatar = Symbol('gravatar');

var _initials = Symbol('initials');

var _isActive = Symbol('isActive');

var _isSelf = Symbol('isSelf');

var _isFirstLogin = Symbol('isFirstLogin');

var _joinTS = Symbol('joinTS');

var _language = Symbol('language');

var _lastName = Symbol('lastName');

var _scope = Symbol('scope');

var _screenDevice = Symbol('screenShareDevice');

var _sms = Symbol('sms');

var _subscriberLogin = Symbol('subscriberLogin');

var _subscriberPin = Symbol('subscriberPin');

var _uid = Symbol('uid');

var _userId = Symbol('userId');

var _timeZone = Symbol('timeZone');

var _videoDevice = Symbol('videoDevice');

var _vmailGreeting = Symbol('vmailGreeting');

var User = /*#__PURE__*/function () {
  function User(_ref) {
    var _ref$attendeeId = _ref.attendeeId,
        attendeeId = _ref$attendeeId === void 0 ? null : _ref$attendeeId,
        _ref$capabilities = _ref.capabilities,
        capabilities = _ref$capabilities === void 0 ? {} : _ref$capabilities,
        _ref$dataDevice = _ref.dataDevice,
        dataDevice = _ref$dataDevice === void 0 ? null : _ref$dataDevice,
        _ref$dialPlan = _ref.dialPlan,
        dialPlan = _ref$dialPlan === void 0 ? null : _ref$dialPlan,
        _ref$displayName = _ref.displayName,
        displayName = _ref$displayName === void 0 ? '' : _ref$displayName,
        _ref$domain = _ref.domain,
        domain = _ref$domain === void 0 ? null : _ref$domain,
        _ref$email = _ref.email,
        email = _ref$email === void 0 ? null : _ref$email,
        _ref$firstName = _ref.firstName,
        firstName = _ref$firstName === void 0 ? null : _ref$firstName,
        _ref$gravatar = _ref.gravatar,
        gravatar = _ref$gravatar === void 0 ? null : _ref$gravatar,
        _ref$initials = _ref.initials,
        initials = _ref$initials === void 0 ? '' : _ref$initials,
        _ref$isActive = _ref.isActive,
        isActive = _ref$isActive === void 0 ? true : _ref$isActive,
        _ref$isSelf = _ref.isSelf,
        isSelf = _ref$isSelf === void 0 ? false : _ref$isSelf,
        _ref$isFirstLogin = _ref.isFirstLogin,
        isFirstLogin = _ref$isFirstLogin === void 0 ? null : _ref$isFirstLogin,
        _ref$joinTS = _ref.joinTS,
        joinTS = _ref$joinTS === void 0 ? null : _ref$joinTS,
        _ref$language = _ref.language,
        language = _ref$language === void 0 ? null : _ref$language,
        _ref$lastName = _ref.lastName,
        lastName = _ref$lastName === void 0 ? null : _ref$lastName,
        _ref$scope = _ref.scope,
        scope = _ref$scope === void 0 ? null : _ref$scope,
        _ref$screenDevice = _ref.screenDevice,
        screenDevice = _ref$screenDevice === void 0 ? null : _ref$screenDevice,
        _ref$sms = _ref.sms,
        sms = _ref$sms === void 0 ? null : _ref$sms,
        _ref$subscriberLogin = _ref.subscriberLogin,
        subscriberLogin = _ref$subscriberLogin === void 0 ? null : _ref$subscriberLogin,
        _ref$subscriberPin = _ref.subscriberPin,
        subscriberPin = _ref$subscriberPin === void 0 ? null : _ref$subscriberPin,
        _ref$uid = _ref.uid,
        uid = _ref$uid === void 0 ? null : _ref$uid,
        _ref$userId = _ref.userId,
        userId = _ref$userId === void 0 ? null : _ref$userId,
        _ref$timeZone = _ref.timeZone,
        timeZone = _ref$timeZone === void 0 ? null : _ref$timeZone,
        _ref$videoDevice = _ref.videoDevice,
        videoDevice = _ref$videoDevice === void 0 ? null : _ref$videoDevice,
        _ref$vmailGreeting = _ref.vmailGreeting,
        vmailGreeting = _ref$vmailGreeting === void 0 ? null : _ref$vmailGreeting;
    (0, _classCallCheck2.default)(this, User);
    this[_attendeeId] = attendeeId;
    this[_capabilities] = capabilities;
    this[_dataDevice] = dataDevice;
    this[_dialPlan] = dialPlan;
    this[_displayName] = displayName;
    this[_domain] = domain;
    this[_email] = email;
    this[_firstName] = firstName;
    this[_gravatar] = gravatar;
    this[_initials] = initials;
    this[_isActive] = isActive;
    this[_isSelf] = isSelf;
    this[_isFirstLogin] = isFirstLogin;
    this[_joinTS] = joinTS;
    this[_language] = language;
    this[_lastName] = lastName;
    this[_scope] = scope;
    this[_screenDevice] = screenDevice;
    this[_sms] = sms;
    this[_subscriberLogin] = subscriberLogin;
    this[_subscriberPin] = subscriberPin;
    this[_uid] = uid;
    this[_userId] = userId;
    this[_timeZone] = timeZone;
    this[_videoDevice] = videoDevice;
    this[_vmailGreeting] = vmailGreeting;
  }

  (0, _createClass2.default)(User, [{
    key: "attendeeId",
    get: function get() {
      return this[_attendeeId];
    },
    set: function set(id) {
      this[_attendeeId] = id;
    }
  }, {
    key: "capabilities",
    get: function get() {
      return this[_capabilities];
    },
    set: function set(capabilities) {
      this[_capabilities] = capabilities;
    }
  }, {
    key: "dataDevice",
    get: function get() {
      return this[_dataDevice];
    },
    set: function set(dataDevice) {
      this[_dataDevice] = dataDevice;
    }
  }, {
    key: "dialPlan",
    get: function get() {
      return this[_dialPlan];
    },
    set: function set(dialPlan) {
      this[_dialPlan] = dialPlan;
    }
  }, {
    key: "displayName",
    get: function get() {
      return this[_displayName];
    },
    set: function set(displayName) {
      this[_displayName] = displayName;
    }
  }, {
    key: "domain",
    get: function get() {
      return this[_domain];
    },
    set: function set(domain) {
      this[_domain] = domain;
    }
  }, {
    key: "email",
    get: function get() {
      return this[_email];
    },
    set: function set(email) {
      this[_email] = email;
    }
  }, {
    key: "firstName",
    get: function get() {
      return this[_firstName];
    },
    set: function set(firstName) {
      this[_firstName] = firstName;
    }
  }, {
    key: "gravatar",
    get: function get() {
      return this[_gravatar];
    },
    set: function set(gravatar) {
      this[_gravatar] = gravatar;
    }
  }, {
    key: "initials",
    get: function get() {
      return this[_initials];
    },
    set: function set(initials) {
      this[_initials] = initials;
    }
  }, {
    key: "isActive",
    get: function get() {
      return this[_isActive];
    },
    set: function set(active) {
      this[_isActive] = active;
    }
  }, {
    key: "isSelf",
    get: function get() {
      return this[_isSelf];
    },
    set: function set(isSelf) {
      this[_isSelf] = isSelf;
    }
  }, {
    key: "isFirstLogin",
    get: function get() {
      return this[_isFirstLogin];
    },
    set: function set(isFirstLogin) {
      this[_isFirstLogin] = isFirstLogin;
    }
  }, {
    key: "joinTS",
    get: function get() {
      return this[_joinTS];
    },
    set: function set(joinTS) {
      this[_joinTS] = joinTS;
    }
  }, {
    key: "language",
    get: function get() {
      return this[_language];
    },
    set: function set(language) {
      this[_language] = language;
    }
  }, {
    key: "lastName",
    get: function get() {
      return this[_lastName];
    },
    set: function set(lastName) {
      this[_lastName] = lastName;
    }
  }, {
    key: "scope",
    get: function get() {
      return this[_scope];
    },
    set: function set(scope) {
      this[_scope] = scope;
    }
  }, {
    key: "screenDevice",
    get: function get() {
      return this[_screenDevice];
    },
    set: function set(screenDevice) {
      this[_screenDevice] = screenDevice;
    }
  }, {
    key: "sms",
    get: function get() {
      return this[_sms];
    },
    set: function set(sms) {
      this[_sms] = sms;
    }
  }, {
    key: "subscriberLogin",
    get: function get() {
      return this[_subscriberLogin];
    },
    set: function set(subscriberLogin) {
      this[_subscriberLogin] = subscriberLogin;
    }
  }, {
    key: "uid",
    get: function get() {
      return this[_uid];
    },
    set: function set(uid) {
      this[_uid] = uid;
    }
  }, {
    key: "userId",
    get: function get() {
      return this[_userId];
    },
    set: function set(userId) {
      this[_userId] = userId;
    }
  }, {
    key: "timeZone",
    get: function get() {
      return this[_timeZone];
    },
    set: function set(timeZone) {
      this[_timeZone] = timeZone;
    }
  }, {
    key: "videoDevice",
    get: function get() {
      return this[_videoDevice];
    },
    set: function set(device) {
      this[_videoDevice] = device;
    }
  }, {
    key: "getCapability",
    value: function getCapability(type) {
      return this[_capabilities][type] || null;
    }
  }, {
    key: "hasCapability",
    value: function hasCapability(type) {
      return !!this[_capabilities][type];
    }
  }, {
    key: "setCapability",
    value: function setCapability(obj) {
      this[_capabilities][obj.type] = obj;
    }
  }, {
    key: "vmailGreeting",
    get: function get() {
      return this[_vmailGreeting];
    },
    set: function set(vmailGreeting) {
      this[_vmailGreeting] = vmailGreeting;
    }
  }, {
    key: "subscriberPin",
    get: function get() {
      return this[_subscriberPin];
    },
    set: function set(subscriberPin) {
      this[_subscriberPin] = subscriberPin;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        attendeeId: this[_attendeeId],
        capabilities: this[_capabilities],
        dataDevice: this[_dataDevice],
        displayName: this[_displayName],
        domain: this[_domain],
        email: this[_email],
        firstName: this[_firstName],
        gravatar: this[_gravatar],
        initials: this[_initials],
        joinTS: this[_joinTS],
        isFirstLogin: this[_isFirstLogin],
        language: this[_language],
        lastName: this[_lastName],
        scope: this[_scope],
        screenDevice: this[_screenDevice],
        sms: this[_sms],
        subscriberLogin: this[_subscriberLogin],
        subscriberPin: this[_subscriberPin],
        uid: this[_uid],
        userId: this[_userId],
        timeZone: this[_timeZone],
        videoDevice: this[_videoDevice],
        vmailGreeting: this[_vmailGreeting]
      };
    }
  }]);
  return User;
}();

exports.default = User;
module.exports = exports.default;